import { render } from "./AlertEditComponent.vue?vue&type=template&id=5b296394&scoped=true"
import script from "./AlertEditComponent.vue?vue&type=script&lang=js"
export * from "./AlertEditComponent.vue?vue&type=script&lang=js"

import "./AlertEditComponent.vue?vue&type=style&index=0&id=5b296394&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b296394"]])

export default __exports__